import { styled } from '../../../theme/stitches.config';

/**
 * Wrapper component that acts as a link, but does not create a CSS box around the content.
 */
export const SMPLinkWrapper = styled.withConfig({ componentId: 'CommonWidget', displayName: 'LinkWrapper' })('a', {
  display: 'contents',
  textDecoration: 'none',
  outline: 'none',

  '&:hover, &:active, &:focus': {
    textDecoration: 'none',
  },
});
